module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "transition": _vm.transition
    }
  }, [_c('div', {
    staticClass: "modal",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.clickMask.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: _vm.modalClass
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('a', {
      staticClass: "close",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.cancel
      }
    }, [_vm._v("x")]), _vm._v(" "), _c('h4', {
      staticClass: "modal-title"
    }, [_vm._t("title", function() {
      return [_vm._v("\n                " + _vm._s(_vm.title) + "\n              ")]
    })], 2)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('transition', {
      attrs: {
        "name": "fade",
        "mode": "out-in"
      }
    }, [(_vm.loading) ? _c('span', [_c('i', {
      staticClass: "fa fa-fw fa-lg fa-spinner fa-spin"
    })]) : _vm._e()]), _vm._v(" "), _c('button', {
      class: _vm.cancelClass,
      attrs: {
        "disabled": _vm.loading,
        "type": "button"
      },
      on: {
        "click": _vm.cancel
      }
    }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('button', {
      class: _vm.okClass,
      attrs: {
        "disabled": _vm.loading,
        "type": "button"
      },
      on: {
        "click": _vm.ok
      }
    }, [_vm._v(_vm._s(_vm.okText))])]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-backdrop in"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d20bf970!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bootstrap/ModalBootstrap.vue
// module id = 367
// module chunks = 12